
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IRequest } from '../interfaces/parameters';
import { map, Observable } from 'rxjs';
import { CommunicationConstants } from '../constants/communication';
import { IResult } from '../interfaces/result';

const API_MAIN = environment.segurity + environment.host + environment.version + environment.typeService;


@Injectable({
  providedIn: 'root'
})
export class ParametersService {

  private url: string = API_MAIN + "company-parameters-api/get-by-company";

  constructor(
    private _http: HttpClient
  ) { }


  
  getParameters(request: IRequest) : Observable<any>{
    return this._http
        .post<IResult<any>>(this.url, request)
        .pipe(
          map((res: IResult<any>) => {
            const [codigosCom, mensajesCom] = CommunicationConstants;
            if (res === null){
                throw new Error(`${codigosCom.ERRORSRV}||${mensajesCom.MSGDATAVACIOSRV}`);
            }
            return res;
          })
        );
    }

  
}